<!--healthOverview 健康总览-->
<template>
  <div class="healthOverview">
    <span class="search" style="display: inline-block; margin-bottom: 20px;">
      <span style="margin-right: 8px;">配电房</span>
      <el-select v-model="searchName" placeholder="请选择" style="margin-right: 20px;">
        <el-option label="1号" value="1" />
        <el-option label="2号" value="2" />
        <el-option label="3号" value="3" />
      </el-select>

      <span style="margin-right: 8px;">设备</span>
      <el-select v-model="searchName2" placeholder="请选择">
        <el-option label="1号" value="1" />
        <el-option label="2号" value="2" />
        <el-option label="3号" value="3" />
      </el-select>


    </span>
    <!-- 第一行 -->
    <div class="one">
      <div class="left" style="background-color: #fff;width: 58%;">
        <div class="t">
          <div class="tit">健康状态监测</div>
          <div class="aa">
            <div class="ul">
              <div class="li">
                <img src="./components/11.png" alt="">
                <div class="text">
                  <div class="num">60.8%</div>
                  <div class="name">健康指数</div>
                </div>
              </div>
              <div class="li">
                <img src="./components/22.png" alt="">
                <div class="text">
                  <div class="num">18</div>
                  <div class="name">剩余保养天数</div>
                </div>
              </div>
              <div class="li">
                <img src="./components/33.png" alt="">
                <div class="text">
                  <div class="num">20.0%</div>
                  <div class="name">电气剩余寿命</div>
                </div>
              </div>
            </div>
            <div class="txt">下次维护时间：2024-05-20 12:00</div>
          </div>
        </div>
      </div>
      <!-- 右边 -->
      <div class="right left">
        <div class="t">
          <div class="tit">环境监测</div>
          <div class="aa">
            <div class="ul">
              <div class="li" style="max-width: 218px;">
                <img src="./components/44.png" alt="">
                <div class="text">
                  <div class="num">18.0 ℃ </div>
                  <div class="name">当前温度</div>
                </div>
              </div>
              <div class="li" style="margin-right: 0;max-width: 218px">
                <img src="./components/55.png" alt="">
                <div class="text">
                  <div class="num">20.6 %</div>
                  <div class="name">当前湿度</div>
                </div>
              </div>
            </div>
            <div class="txt">
              震动级别：<el-tag type="success" size="mini" style="margin-right: 20px;"> <i class="ii"></i> 低</el-tag>
              腐蚀级别：<el-tag type="warning" size="mini" style="margin-right: 20px;"> <i class="ii"
                  style="background-color: #FF7B00;"></i> 中</el-tag>
              粉尘级别：<el-tag type="danger" size="mini"> <i class="ii" style="background-color: #FF2807;"></i> 高</el-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 第2行 -->
    <div class="tow one">
      <div class="t" style="height: 20vh;min-height: 142px;">
        <div class="tit">数据监测</div>
        <div class="aa">
          <div class="box  ">
            <div class="box_left">
              <img src="./components/66.png" alt="">
              <div class="tt">
                <div class="num">60.8 A</div>
                <div class="name">平均负载电流</div>
              </div>
            </div>
            <div class="box_right">
              <div class="a">
                <span>操作次数：<div class="txted">2 次</div></span>
                <span>任意警报：<div class="txted">20 次</div></span>
                <span style="width: auto;">
                  <div class="txted">实际位置：珠海市高新区金鼎镇公安局</div>
                </span>
              </div>
              <div class="b">
                <span>操作模式：<div class="txted">远程连接</div></span>
                <span>脱扣警报：<div class="txted">29 次</div></span>
                <span>实际状态：<i class="ii"></i>
                  <div class="txted" style="color: #0C7031;">在线</div>
                </span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="four" style="margin-bottom: 40px;">
      <div class="left">
        <div class="tit" style="position: absolute;z-index: 999;width: 100%;  align-items: center;"><span>警报事件</span>
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="timestamp" size="mini" :picker-options="pickerOptions">
          </el-date-picker>
        </div>
        <div class="t" style="margin-top: 12px;height: auto;">
          <vchart class="vchart" ref='vchart'></vchart>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import vchart from '../../components/module/Charts/chart.vue';//echart图 
  export default {
    components: {
      vchart
    },
    data () {
      return {
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },

        },
        value1: '',
        searchName: '',
        searchName2: '',
        barOption: {
          toolbox: {
            show: true,
            top: 0,
            right: '400',
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
            }
          },
          "xAxis": [{
            "type": "category",
            "data": ['2024-05-21','2024-05-22','2024-05-23','2024-05-24','2024-05-25','2024-05-26','2024-05-27',],
            "axisLabel": {
              "textStyle": {
                "color": "#000"
              }
            },
            "splitLine": {
              "lineStyle": {
                "type": "dashed",
                "color": "#6f7284"
              }
            }
          }],
          "yAxis": [{
            "title": "能耗值（KWH）",
            "type": "value",
            "axisLabel": {
              "textStyle": {
                "color": "#3D3D3D"
              }
            },
            "splitLine": {
              "lineStyle": {
                "type": "dashed",
                "color": "#E5E5E5"
              }
            }
          }],
          "legend": {
            left: 'center',
            'bottom': 2,
          },
          "backgroundColor": "",
          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": false
            }
          },
          "grid": {
            "left": "1%",
            "right": "40",
            "bottom": "10%",
            "top": "25%",
            "containLabel": true
          },
          "series": [{
            "name": "消息",
            "type": "bar",
            barWidth: '16',
            stack: 'total',
            "itemStyle": {
              "normal": {
                "color": {
                  "x": 0,
                  "y": 0,
                  "x2": 0,
                  "y2": 1,
                  "type": "linear",
                  "global": false,
                  "colorStops": [{
                    "offset": 0,
                    "color": "#118c3d"
                  },{
                    "offset": 1,
                    "color": "#118c3d"
                  }]
                }
              },
            },
            "data": [200,100,200,100,100,200,200]
          },{
            "name": "预警",
            "type": "bar",
            barWidth: '16',
            stack: 'total',
            "itemStyle": {
              "normal": {
                "color": {
                  "x": 0,
                  "y": 0,
                  "x2": 0,
                  "y2": 1,
                  "type": "linear",
                  "global": false,
                  "colorStops": [{
                    "offset": 0,
                    "color": "#ffa44f"
                  },{
                    "offset": 1,
                    "color": "#ffa44f"
                  }]
                }
              },
            },
            "data": [200,200,200,200,200,200,100]
          },{
            "name": "告警",
            "type": "bar",
            barWidth: '16',
            stack: 'total',
            "itemStyle": {
              "normal": {
                "color": {
                  "x": 0,
                  "y": 0,
                  "x2": 0,
                  "y2": 1,
                  "type": "linear",
                  "global": false,
                  "colorStops": [{
                    "offset": 0,
                    "color": "#f34e4e"
                  },{
                    "offset": 1,
                    "color": "#f34e4e"
                  }]
                }
              },
            },
            "data": [100,100,50,50,100,50,100]
          }]
        },

        nowScale: 50, //当前缩放倍率
        token: '', //token
        ids: [],
        svgPath: '',
      }
    },

    mounted () {
      this.$refs.vchart.setData(this.barOption,true);
    },
    destroyed () {

    },
    methods: {

    }
  }
</script>
<style>
  /* .healthOverview .el-range-editor--mini .el-range-input {
    background-color: red;
  } */

  .healthOverview .el-range-editor--mini .el-range-input:focus {
    outline: none;
    box-shadow: none;
    border-color: initial;
    background-color: initial;
  }
</style>
<style lang="scss" scoped>
  .four {
    display: flex;
    margin-top: 12px;
    position: relative;

    .box {
      display: flex;
    }

    .left {
      background-color: #fff;
      border-radius: 4px;
      padding-left: 12px;
      width: 100%;
    }


  }

  .tow {
    width: 100%;

    .box {
      display: flex;
      padding-bottom: 23px;

      .box_right {
        display: flex;
        flex-direction: column;
        /* 自动布局子元素 */

        font-family: Microsoft YaHei;
        font-size: 13px;
        color: #666;

        .txted {
          color: #1A1A1A;
          display: inline-block;
        }

        .a {
          margin-bottom: 20px;
        }

        span {
          display: inline-block;
          width: 200px;
        }
      }

      .box_left {
        display: flex;
        width: 222px;
        border-right: 1px solid #E5E5E5;
        margin-right: 20px;
        align-items: center;

        .num {
          /* 自动布局子元素 */
          height: 23px;
          font-size: 20px;
          font-weight: bold;
          letter-spacing: 0em;
          color: #1A1A1A;
          margin-bottom: 4px;
        }

        .name {
          /* 自动布局子元素 */
          font-family: Microsoft YaHei;
          font-size: 13px;
          color: #666;
        }

        img {
          margin-right: 12px;
          margin-left: 10px;
          width: 48px;
          height: 48px;
        }
      }
    }

    .t {
      display: flex;
      flex-direction: column;
      background-color: #fff;
      padding-left: 12px;
      overflow: hidden;
      border-radius: 4px;
      width: 100%;
      height: 23vh;
      min-height: 160px;

      .aa {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }

  .ii {
    /* 自动布局子元素 */
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #00AC3E;
    margin-right: 2px;
  }

  .ul {
    display: flex;

    .li {
      flex: 1;
      border-radius: 4px;
      /* 自动布局 */
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 16.5px 12px;
      gap: 12px;
      margin-right: 12px;
      background: #F7F9FA;


      .num {
        /* 自动布局子元素 */
        height: 23px;
        font-family: Arial;
        font-size: 20px;
        font-weight: bold;
        font-variation-settings: "opsz" auto;
        color: #1A1A1A;
      }

      .name {
        /* 自动布局子元素 */
        height: 17px;
        font-family: Microsoft YaHei;
        font-size: 13px;
        font-weight: normal;

        font-variation-settings: "opsz" auto;
        color: #666;
      }
    }
  }

  .four {
    display: flex;
    margin-top: 12px;
    position: relative;

    .box {
      display: flex;
    }

    .left {
      background-color: #fff;
      border-radius: 4px;
      padding-left: 12px;
      width: 100%;
    }


  }

  .one {
    display: flex;
    margin-bottom: 12px;

    .right {
      background-color: #fff;
      flex: 1;
      margin-left: 12px;
      border-radius: 4px;

      .map {
        position: relative;
        margin-right: 12px;
      }
    }
  }

  .healthOverview {
    background-color: #edf0f4;
    padding: 20px;
  }

  .left {
    .txt {
      font-family: Microsoft YaHei;
      font-size: 13px;
      letter-spacing: 0em;
      margin-top: 15px;
      color: #666;
    }

    .t {
      background-color: #fff;
      padding-left: 12px;
      margin-bottom: 12px;
      overflow: hidden;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      height: 23vh;
      min-height: 170px;

      .aa {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }
  }

  .tit {
    height: 18px;
    font-family: Microsoft YaHei;
    font-size: 14px;
    font-weight: bold;
    color: #1A1A1A;
    margin-top: 12px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-right: 20px;

    .line {
      width: 52px;
      height: 17px;
      font-family: Microsoft YaHei;
      font-size: 13px;
      font-weight: normal;
      color: #666;
      cursor: pointer;
    }
  }

  .vchart {
    width: 100%;
    min-height: 240px;
    height: 30vh;
  }
</style>